import { render, staticRenderFns } from "./SavedJobsPage.vue?vue&type=template&id=d5f37310&scoped=true&"
import script from "./SavedJobsPage.vue?vue&type=script&lang=js&"
export * from "./SavedJobsPage.vue?vue&type=script&lang=js&"
import style0 from "./SavedJobsPage.vue?vue&type=style&index=0&id=d5f37310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f37310",
  null
  
)

export default component.exports